import { TabsGroup, TabsContent } from 'ui/tabsGroup';
import { useSTOInsightsCoreContext } from 'modules/intelligentInsights/stoInsights/contexts/CoreContext';
import { STOContent } from 'modules/intelligentInsights/stoInsights/components/breakdownByMedium/mediumTabContent/STOContent';
import { STOContentSkeleton } from 'modules/intelligentInsights/stoInsights/components/breakdownByMedium/mediumTabContent/STOContentSkeleton';
import { STOMessageMediumTabs } from 'modules/intelligentInsights/stoInsights/types';
import { EmailLine24, PushLine24, SmsLine24 } from 'ui/icons';
import {
  ButtonText,
  StyledNavTabsList,
  StyledNavTrigger,
  Wrapper,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownTabs.styles';

export const STO_BREAKDOWN_TABS_TEST_ID = 'sto-insights-breakdown-tabs';

export const STOBreakdownTabs = () => {
  const { selectedMedium, setSelectedMedium, isReady } = useSTOInsightsCoreContext();

  return (
    <Wrapper data-test={STO_BREAKDOWN_TABS_TEST_ID}>
      <TabsGroup
        value={selectedMedium}
        onValueChange={(newTab) => {
          setSelectedMedium(newTab as STOMessageMediumTabs);
        }}
      >
        <StyledNavTabsList>
          <StyledNavTrigger
            data-test={`${STOMessageMediumTabs.Email}-medium-tab-trigger`}
            key={STOMessageMediumTabs.Email}
            value={STOMessageMediumTabs.Email}
          >
            <EmailLine24 />
            <ButtonText>{STOMessageMediumTabs.Email}</ButtonText>
          </StyledNavTrigger>
          <StyledNavTrigger
            data-test={`${STOMessageMediumTabs.Push}-medium-tab-trigger`}
            key={STOMessageMediumTabs.Push}
            value={STOMessageMediumTabs.Push}
          >
            <PushLine24 />
            <ButtonText>{STOMessageMediumTabs.Push}</ButtonText>
          </StyledNavTrigger>
          <StyledNavTrigger
            data-test={`${STOMessageMediumTabs.SMS}-medium-tab-trigger`}
            key={STOMessageMediumTabs.SMS}
            value={STOMessageMediumTabs.SMS}
          >
            <SmsLine24 />
            <ButtonText>{STOMessageMediumTabs.SMS}</ButtonText>
          </StyledNavTrigger>
        </StyledNavTabsList>
        <TabsContent value={STOMessageMediumTabs.Email}>
          {!isReady ? <STOContentSkeleton /> : <STOContent />}
        </TabsContent>
        <TabsContent value={STOMessageMediumTabs.Push}>
          {!isReady ? <STOContentSkeleton /> : <STOContent />}
        </TabsContent>
        <TabsContent value={STOMessageMediumTabs.SMS}>
          {!isReady ? <STOContentSkeleton /> : <STOContent />}
        </TabsContent>
      </TabsGroup>
    </Wrapper>
  );
};
